// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 886 ? "model" : chunkId) + "." + {"573":"0e2d5119","886":"cfe113dd"}[chunkId] + ".css";
};